<template>
    <div><b>ZenFile</b> &quot;{{item.name}}&quot; <b>Type:</b>{{item.typeDescription}} <b>Chunks:</b> {{item.children.length}}</div>
    <div v-if="item.tones.length>0">
        <b>Tones Found:</b>
        <ul>
    <li v-for="tone in item.tones" :key="tone.key">
        <i @click="tone.saveFile()" class='ms-1 me-2 bi-download clC' style="font-size: 1rem;"></i>{{tone.name}} {{tone.type}} {{tone.location}}
    </li>
        </ul>
    </div>
</template>

<script>
/* eslint-disable vue/no-unused-components */


export default {
    name: 'ZenFileComponent',
    components: {
    },
    props: [
        'item'
    ]
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
